import { useCallback, useEffect, useRef, useState } from 'react'

import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import ReclamacoesService from '../../../services/database/ReclamacoesService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { FormReclamacao } from '../FormReclamacao'

export function ModalEdit({ isOpen, onClose, code, loadReclamacoes }) {
  const [isRequestLoading, setIsRequestLoading] = useState(false)
  const [isLoadingData, setIsLoadingData] = useState(true)

  const formReclamacaoRef = useRef(null)

  async function handleSubmit() {
    try {
      setIsRequestLoading(true)

      if (formReclamacaoRef.current) {
        const reclamacao = formReclamacaoRef.current?.getReclamacao()

        await ReclamacoesService.update(code, reclamacao)

        toast.success('Reclamação atualizada com sucesso!')

        loadReclamacoes()
        onClose()
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível editar a reclamação!')
    } finally {
      setIsRequestLoading(false)
    }
  }

  const getByCode = useCallback(async () => {
    try {
      setIsLoadingData(true)

      const reclamacao = await ReclamacoesService.getByCode(code)

      formReclamacaoRef.current?.setReclamacao(reclamacao)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível carregar as informações da reclamação!',
      )
    } finally {
      setIsLoadingData(false)
    }
  }, [code])

  useEffect(() => {
    getByCode()
  }, [getByCode])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modalzpl"
      centered
    >
      <div
        style={{
          padding: 20,
        }}
      >
        <FormReclamacao
          ref={formReclamacaoRef}
          onSubmit={handleSubmit}
          onClose={onClose}
          isRequestLoading={isRequestLoading}
          loadingData={isLoadingData}
        />
      </div>
    </Modal>
  )
}
